// extracted by mini-css-extract-plugin
export var layoutContainer = "_dp-0";
export var layoutContainerNoRounding = "_dp-6";
export var layoutContainerOpen = "_dp-5";
export var layoutContainerResizing = "_dp-1";
export var mainContent = "_dp-2";
export var resizeDivider = "_dp-3";
export var slidePanel = "_dp-4";